import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp?: number;
}

export function isJwtExpired(token: string): boolean {
  try {
    const { exp } = jwtDecode<JwtPayload>(token);
    if (exp === undefined) {
      return false;
    }
    return Date.now() >= exp * 1000;
  } catch {
    return false;
  }
}

export function isSessionTokenValid(token: string | null): boolean {
  if (!token) {
    return false;
  }
  if (token.split('.').length === 3) {
    return !isJwtExpired(token);
  }
  return true;
}
